import numeral from "numeral"

numeral.register("locale", "zh-cn", {
  delimiters: {
    thousands: ",",
    decimal: ".",
  },
  abbreviations: {
    thousand: "千",
    million: "百万",
    billion: "十亿",
    trillion: "万亿",
  },
  ordinal: function (number) {
    return "."
  },
  currency: {
    symbol: "¥",
  },
})
numeral.locale("zh-cn")

// 自定义一个格式转换器，要求将数值转换为万元
numeral.register("format", "wan", {
  regexps: {
    format: /(w)/,
    unformat: /(w)/,
  },
  format: function (value, format, roundingFunction) {
    const space = numeral._.includes(format, " w") ? " " : ""
    let output = ""

    value = value / 10000

    // check for space before w
    format = format.replace(/\s?w/, "")

    output = numeral._.numberToFormat(value, format, roundingFunction)

    if (numeral._.includes(output, ")")) {
      const outputArray = output.split("")

      outputArray.splice(-1, 0, space + "万")

      output = outputArray.join("")
    } else {
      output = output + space + "万"
    }

    return output
  },
  unformat: function (string) {
    if (string === null || string === undefined) {
      return string
    }
    if (typeof string !== "string") {
      return string
    }
    const value = numeral._.stringToNumber(string)
    if (isNaN(value)) {
      return null
    }
    // 将万元转换为数值
    return value * 10000
  },
})
export default numeral
